// profile/ProfileTabs.jsx
import React, { useMemo } from 'react';
import styles from './styles/ProfileTabs.module.css';
import { TABS_BY_ROLE } from './tabs';
import { useTranslation } from 'react-i18next';

const ProfileTabs = ({ userRole, isOwner = false, activeTab, setActiveTab }) => {
  const { t } = useTranslation('profile');
  const tabs = useMemo(() => {
    return TABS_BY_ROLE[userRole] ? [...TABS_BY_ROLE[userRole]] : [];
  }, [userRole]);

  return (
    <div className={styles.profileTabs}>
      {tabs.map((tabKey) => (
        <button
          key={tabKey}
          type="button"
          className={`${styles.tab} ${activeTab === tabKey ? styles.active : ''}`}
          onClick={() => setActiveTab(tabKey)}
        >
          {tabKey === 'upcoming' && (
            <img src="/icons/calender_mono.svg" alt={t('tabUpcoming')} className={styles.tabIcon} />
          )}
          {tabKey === 'purchased' && (
            <img src="/icons/calender_mono.svg" alt={t('tabPurchased')} className={styles.tabIcon} />
          )}
          {tabKey === 'past' && (
            <img src="/icons/clock.svg" alt={t('tabPast')} className={styles.tabIcon} />
          )}
          {tabKey === 'gallery' && (
            <img src="/icons/image_mono.svg" alt={t('tabGallery')} className={styles.tabIcon} />
          )}
          {tabKey === 'upcoming' && t('tabUpcoming')}
          {tabKey === 'past' && t('tabPast')}
          {tabKey === 'gallery' && t('tabGallery')}
          {tabKey === 'purchased' && t('tabPurchased')}
        </button>
      ))}
    </div>
  );
};

export default ProfileTabs;
